import { NarrativeTextVis, NtvPluginManager, createCustomPhraseFactory } from "@antv/ava-react";
import { Skeleton, Tooltip } from "antd";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import React from "react";
import { SmlAsset, SmlJsonQuery } from "@src/types/intelligence-search";
import { SpecSectionsBuilder } from "@src/util/intelligence-search/builder/narrative-manager";
import { LoadingComponent } from "@src/components/loading-custom";
import { ISLoadingTips, LoadingMessage } from "@src/constant/loading-message";

const pluginManager = new NtvPluginManager([
    // step2. 通过工厂函数（createXxx）定义插件；
    createCustomPhraseFactory({
        key: "ama-sml-asset",
        content: (value, meta) => {
            const { textColor } = getMemberColor(meta.assetMeta.asset_type);
            return (
                // <Tooltip title={JSON.stringify(meta.a)}>
                <Tooltip title={meta.assetMeta.description}>
                    <span
                        style={{
                            color: textColor,
                        }}
                    >
                        {value}
                    </span>
                </Tooltip>
            );
        },
    }),
]);

export const NarrativeTitle: React.FC<{
    loading?: boolean;
    disabled?: boolean;
    jsonQuery: SmlJsonQuery;
    referencedAssets: SmlAsset[];
}> = ({ loading = false, disabled = false, jsonQuery, referencedAssets }) => {
    const specBuilder = new SpecSectionsBuilder(referencedAssets ?? [], jsonQuery ?? {});
    const spec = specBuilder.build();

    if (disabled || !spec) {
        return <></>;
    }

    if (loading) {
        return <Skeleton active />;
    }

    return (
        <NarrativeTextVis
            spec={spec}
            // step3. 传入 NarrativeTextVis 组件；
            pluginManager={pluginManager}
        />
    );
};
